import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import SidebarFilterCareer from "../component/SidebarFilterCareer";
import JobCard from "../component/JobCard";
import BreadCumb from "../component/BreadCumb";
import {Helmet} from "react-helmet-async";

export default function CareerPage() {
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const initialSearch = searchParams.get('search') || '';
    const initialTab = searchParams.get('tab') || 'All Jobs';
    const initialCategories = searchParams.get('categories') ? searchParams.get('categories').split(',') : [];
    const initialCountries = searchParams.get('countries') ? searchParams.get('countries').split(',') : (initialTab !== 'All Jobs' ? [initialTab] : []);

    const [searchTerm, setSearchTerm] = useState(initialSearch);
    const [selectedTab, setSelectedTab] = useState(initialTab);
    const [sortBy, setSortBy] = useState('Latest');
    const [jobs, setJobs] = useState([]);
    const [loading, setLoading] = useState(true);

    // সাইডবারের মতো ডাইনামিক কান্ট্রি লিস্ট রাখার স্টেট
    const [countries, setCountries] = useState([]);

    const [filters, setFilters] = useState({
        categories: initialCategories,
        countries: initialCountries
    });

    const API_URL = process.env.REACT_APP_API_BASE_URL;
    const CAREERS_ENDPOINT = process.env.REACT_APP_API_CAREERS;
    const COUNTRIES_ENDPOINT = process.env.REACT_APP_API_COUNTRIES;

    // ১. ব্যাকএন্ড থেকে সরাসরি কান্ট্রি লিস্ট ফেচ করা (ঠিক যেমনটা SidebarFilter-এ করা হয়েছে)
    useEffect(() => {
        axios.get(`${API_URL}${COUNTRIES_ENDPOINT}`)
            .then(res => {
                setCountries(res.data.data || res.data);
            })
            .catch(err => console.error("Error fetching countries for tabs", err));
    }, [API_URL, COUNTRIES_ENDPOINT]);

    // ২. জবস ফেচ করা
    useEffect(() => {
        setLoading(true);
        const params = new URLSearchParams();
        if (searchTerm) params.append('search', searchTerm);
        if (selectedTab && selectedTab !== 'All Jobs') params.append('tab', selectedTab);
        if (filters.categories.length > 0) params.append('categories', filters.categories.join(','));
        if (filters.countries.length > 0) params.append('countries', filters.countries.join(','));
        params.append('sort', sortBy);

        axios.get(`${API_URL}${CAREERS_ENDPOINT}?${params.toString()}`)
            .then(res => {
                setJobs(res.data.data || res.data);
                setLoading(false);
            })
            .catch(err => {
                console.error("Error fetching careers:", err);
                setLoading(false);
            });
    }, [searchTerm, selectedTab, filters, sortBy, API_URL, CAREERS_ENDPOINT]);

    const updateURL = (updatedTab, updatedSearch, updatedFilters) => {
        const params = {};
        if (updatedSearch) params.search = updatedSearch;
        if (updatedTab && updatedTab !== 'All Jobs') params.tab = updatedTab;
        if (updatedFilters.categories.length > 0) params.categories = updatedFilters.categories.join(',');
        if (updatedFilters.countries.length > 0) params.countries = updatedFilters.countries.join(',');
        setSearchParams(params);
    };

    const handleTabClick = (tabName) => {
        setSelectedTab(tabName);
        const updatedCountries = tabName === 'All Jobs' ? [] : [tabName];

        // সাইডবারের চেকবক্স এবং ট্যাবের ফিল্টার যেন সিংক্রোনাইজ থাকে
        const newFilters = { ...filters, countries: updatedCountries };
        setFilters(newFilters);
        updateURL(tabName, searchTerm, newFilters);
    };

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        updateURL(selectedTab, value, filters);
    };

    const handleFilterChange = (newFilters) => {
        setFilters(newFilters);
        updateURL(selectedTab, searchTerm, newFilters);
    };

    return (
        <>
            <Helmet>
                <title>Tarif Overseas Ltd. | Build Your Career With Us</title>
                <meta name="description" content="Tarif Overseas Ltd. is a trusted overseas recruitment agency in Bangladesh providing professional manpower recruitment services."/>
                <link rel="canonical" href={`https://tarifoverseasltd.com/career`}/>
            </Helmet>
            <div className="min-vh-100 bg-light d-flex flex-column font-sans">

                <BreadCumb image={"career.webp"} />

                {/* Hero Banner */}
                <header className="bg-primary text-white py-5 text-center shadow-sm" style={{ background: 'linear-gradient(135deg, #0d1b2a 0%, #1b263b 50%, #415a77 100%)' }}>
                    <div className="container">
                        <p className="text-warning fw-semibold small mb-4">"Safe, Secure & Legal Way to Work Abroad - No Visa, No Money"</p>
                        <div className="badge bg-warning text-dark px-3 py-2 rounded-pill mb-4 small fw-semibold">
                            "নিরাপদভাবে এবং সহজে – Global Opportunities, Real Results"
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-md-8 col-lg-6">
                                <div className="input-group shadow bg-white p-1 rounded">
                                    <input
                                        type="text"
                                        className="form-control border-0 shadow-none small"
                                        placeholder="Search by job title, category or country..."
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                    />
                                    <button className="btn btn-warning fw-bold text-white px-4" type="button" style={{ backgroundColor: '#f59e0b' }}>
                                        Search Jobs
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>

                {/* Green Marquee */}
                <div className="bg-success text-white py-2 px-3 small text-center overflow-hidden">
                    <span className="fw-medium">📢 বিভিন্ন ক্যাটাগরিতে জরুরি ভিত্তিতে লোক নিয়োগ চলছে। কোনো ভিসা ফি ছাড়াই আবেদন করুন!</span>
                </div>

                {/* Dynamic Filter Pills Bar (DB থেকে আসা কান্ট্রি দিয়ে তৈরি) */}
                <div className="bg-white border-bottom py-2 px-3">
                    <div className="container d-flex gap-2 overflow-x-auto pb-1" style={{ whiteSpace: 'nowrap' }}>
                        <button
                            onClick={() => handleTabClick('All Jobs')}
                            className={`btn btn-sm rounded-pill px-3 fw-semibold ${selectedTab === 'All Jobs' ? 'btn-primary' : 'btn-outline-secondary'}`}
                            style={{ fontSize: '12px' }}
                        >
                            All Jobs
                        </button>
                        {countries.map((country) => (
                            <button
                                key={country.id}
                                onClick={() => handleTabClick(country.name)}
                                className={`btn btn-sm rounded-pill px-3 fw-semibold ${selectedTab === country.name ? 'btn-primary' : 'btn-outline-secondary'}`}
                                style={{ fontSize: '12px' }}
                            >
                                {country.name}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Main Content Layout */}
                <main className="container my-4 flex-grow-1">
                    <div className="row g-4">
                        <div className="col-lg-3">
                            <SidebarFilterCareer filters={filters} onFilterChange={handleFilterChange} />
                        </div>

                        <div className="col-lg-9">
                            <div className="card shadow-sm border p-3 mb-3 d-flex flex-row justify-content-between align-items-center">
                                <span className="fw-bold text-secondary small">
                                    Available Jobs <span className="badge bg-primary rounded-pill ms-1">{jobs.length}</span>
                                </span>
                                <select
                                    className="form-select form-select-sm w-auto shadow-none"
                                    value={sortBy}
                                    onChange={(e) => setSortBy(e.target.value)}
                                >
                                    <option value="Latest">Sort by: Latest</option>
                                    <option value="Salary">Sort by: Salary (High to Low)</option>
                                </select>
                            </div>

                            <div>
                                {loading ? (
                                    <div className="text-center py-5 bg-white rounded border shadow-sm">
                                        <p className="text-muted mb-0">Loading jobs...</p>
                                    </div>
                                ) : jobs.length > 0 ? (
                                    jobs.map((job) => (
                                        <JobCard key={job.id} job={job} />
                                    ))
                                ) : (
                                    <div className="text-center py-5 bg-white rounded border shadow-sm">
                                        <p className="text-muted mb-0">No jobs found matching your criteria.</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </>
    );
}